export enum EducationLevelEnum {
  NoResponse = 0,
  Elementary = 1,
  SomeHighschool = 2,
  Highschool = 3,
  Trade = 4,
  Associate = 5,
  Bachelor = 7,
  Masters = 8,
  PhD = 9
}

export const EducationLevelOptions = [
{ id: 0, label: 'No Response' },
{ id: 1, label: 'Elementary School' },
{ id: 2, label: 'Some high school' },
{ id: 3, label: 'Completed high school' },
{ id: 4, label: 'Trade/Vocational school' },
{ id: 5, label: 'Associate Degree/certificate' },
{ id: 7, label: 'Bachelor\'s degree' },
{ id: 8, label: 'Master\'s degree' },
{ id: 9, label: 'PhD' }
];
